import gql from "graphql-tag";

export const mutation_deleteUserAccessToken = gql`
  mutation DeleteUserAccessToken($input: DeleteUserAccessTokenRequestInput) {
    DeleteUserAccessToken(input: $input) {
      deleted
    }
  }
`;
